export { GuestDetailsStepContainer as GuestDetailsStep } from './container';
